
document.addEventListener('DOMContentLoaded', function () {
    var hyswiper = new Swiper('.brands_block', {
        loop: true,
        speed: 3000,
        freeMode: true,
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: true,
        },
        slidesPerView: 6,
        spaceBetween: 1,
        centeredSlides: true,
        watchSlidesProgress: true,
        mousewheels: true,
        breakpoints: {
            320: {
                slidesPerView: 2.2,
            },

            450: {
                slidesPerView: 3,
            },

            749: {
                slidesPerView: 5,
            },

            1024: {
                slidesPerView: 7,
            },

        },
    });
    hyswiper.el.onmouseover = function () {
        hyswiper.autoplay.stop();
    };

    hyswiper.el.onmouseout = function () {
        hyswiper.autoplay.start();
    };
});
